module.exports = __webpack_public_path__ + "static/media/termos-de-uso.34247ccf.pdf";